export function formatCardExpiry(month, year) {
  if (month == null || year == null) return null;
  const m = Number(month);
  const y = Number(year);
  if (!Number.isFinite(m) || !Number.isFinite(y) || m < 1 || m > 12) return null;
  return `${String(m).padStart(2, "0")} / ${y}`;
}
